import type { AffineTextAttributes } from '@blocksuite/affine-shared/types';
import { normalizeUrl } from '@blocksuite/affine-shared/utils';
import { StdIdentifier } from '@blocksuite/std';
import { InlineSpecExtension } from '@blocksuite/std/inline';
import { html } from 'lit';
import { z } from 'zod';

export const LinkInlineSpecExtension =
  InlineSpecExtension<AffineTextAttributes>('link', provider => {
    const std = provider.get(StdIdentifier);
    return {
      name: 'link',
      schema: z.object({
        link: z.string().optional().nullable().catch(undefined),
      }),
      match: delta => {
        return !!delta.attributes?.link;
      },
      renderer: ({ delta, editor, startOffset }) => {
        // A link can span several deltas when its text has mixed formatting.
        const previousLink = startOffset
          ? editor.getDeltaByRangeIndex(startOffset)?.attributes?.link
          : undefined;
        const isLinkStart =
          startOffset === 0 ||
          editor.yTextString[startOffset - 1] === '\n' ||
          normalizeUrl(previousLink ?? '') !==
            normalizeUrl(delta.attributes?.link ?? '');
        return html`<affine-link
          .std=${std}
          .delta=${delta}
          .isLinkStart=${isLinkStart}
        ></affine-link>`;
      },
    };
  });
